import {forEach} from "lodash";

export function restoreInput(storageKey, inputName, inputTag = "input") {
    const storedValue = sessionStorage.getItem(storageKey);

    if (![null, undefined, ""].includes(storedValue))
        $(inputTag + '[name="' + inputName + '"]').val(storedValue);

    sessionStorage.removeItem(storageKey);
    return storedValue;
}

export function restoreCheckbox(storageKey, input) {
    const isChecked = sessionStorage.getItem(storageKey);

    if (isNotNull(isChecked)) input.prop("checked", parseBool(isChecked));

    sessionStorage.removeItem(storageKey);
}

export function saveInputPrevious(input) {
    const value = input.hasClass("money")
        ? input.money().toString()
        : input.val();

    input.data("previous", value);
}

export function reIndexInput(input, index) {
    let name = $(input).attr("name");

    if (name !== undefined) {
        name = name.replace(/\[[-?\d]+]/g, `[${index}]`);
        $(input).attr("name", name);
    }
}

export function isValidTrue(value) {
    const isValidTrueString =
        typeof value === "string" &&
        (value.toLowerCase() === "true" || value === "1");

    return isValidTrueString || value === 1 || value === true;
}

export function isValidFalse(value) {
    const isValidFalseString =
        typeof value === "string" &&
        (value.toLowerCase() === "false" || value === "0");

    return isValidFalseString || value === 0 || value === false;
}

export function parseBool(value) {
    if (isValidTrue(value)) return true;
    else if (isValidFalse(value)) return false;

    return null;
}

export function getInputValue(inputElement) {
    let value;

    if (inputElement.is(":checkbox")) {
        value = inputElement.is(":checked");
    } else if (inputElement.hasClass("money") || inputElement.hasClass("exchange-rate") || inputElement.hasClass("percentages") ) {
        value = inputElement.money().toFloat();
    } else {
        value = inputElement.val();
    }

    return value;
}

export function parseCommaValue(number) {
    return number.toString().replace(".", ",");
}

export function isNull(value, withZero = true) {
    return [null, undefined, "", withZero ? "0" : ""].includes(value);
}

export function isNotNull(value, withZero = true) {
    return !isNull(value, withZero);
}

export function caseInsensitiveSortFunction() {
    return function (a, b) {
        if (a.text.toLowerCase() < b.text.toLowerCase()) return -1;
        else if (a.text.toLowerCase() > b.text.toLowerCase()) return 1;
        return 0;
    };
}

export function redirect(location, params = {}) {
    const queryArray = Object.keys(params).map(function (key) {
        return encodeURI(`${key}=${params[key]}`);
    });
    const queryString = queryArray.join("&");
    const hrefLocation = queryString ? `${location}?${queryString}` : location;

    setTimeout(() => window.location.href = hrefLocation, 50);
}

export function openInNewWindow(url) {
    setTimeout(() => {
        window.open(url, "_blank");
    }, 50);
}

export function clearTooltips() {
    $('div.tooltip[role="tooltip"]').remove();
}

export function replaceInText(text, toReplace = {}) {
    forEach(toReplace, (value, key) => {
        text = text.replace(key, value);
    });

    return text;
}

export function toggleCheckboxReadonly(checkbox, readonly = false) {
    checkbox.prop("readonly", readonly);

    if (readonly) {
        checkbox.addClass("disabled-checkbox");
        checkbox.closest("label").addClass("disabled-label");
    } else {
        checkbox.removeClass("disabled-checkbox");
        checkbox.closest("label").removeClass("disabled-label");
    }
}

export function changeSelect2Options(select, data) {
    if (select.data('select2')) {
        select.select2('destroy').empty().select2({
            data: data, // Twoje dane
            language: {
                noResults: function() {
                    return $.i18n._('no_positions'); // Twój komunikat
                }
            }
        });
    }
}

export function changeSelect2OptionsWithTemplateResult(select, data,templateResult) {
    if (select.data('select2')) {
        select.select2('destroy').empty().select2({
            data: data, // Twoje dane
            language: {
                noResults: function() {
                    return $.i18n._('no_positions'); // Twój komunikat
                }
            },
            templateResult: templateResult,
        });
    }
}

export function toggleSlide(element, visible) {
    if (visible) {
        element.slideDown();
    } else {
        element.slideUp();
    }
}

export function hasSameSign(value1, value2) {
    return (value1 * value2) >= 0;
}

export function getDataFormStorage(storage, storageKey, deleteKey = true) {
    let stored = storage.getItem(storageKey);
    if(deleteKey){
        storage.removeItem(storageKey);
    }


    if (stored !== null) return JSON.parse(stored);

    return null;
}

export function pushValueToObjectKey(object, key, value) {
    object[key] === undefined ? object[key] = [value] : object[key].push(value);
}

export function addValueToObjectKey(object, key, value) {
    object[key] === undefined ? object[key] = value : object[key] += value;
}

export function parseDate(date) {
    return parseFloat(date.toString().replace(/\-/g, ""));
}

export function toggleButtonLoading(button, loading = false, removeClass = 'fa-search', addClass = 'fa-circle-notch fa-spin') {
    if (loading) {
        button.find('i').removeClass(removeClass).addClass(addClass);
    } else {
        button.find('i').removeClass(addClass).addClass(removeClass);
    }
}

export function prepareColCb(disabled = false, data = {}) {
    const cbInput = $('<input />', {type: 'checkbox', disabled, ...data});

    return $('<td/>', {class: 'td-padding'}).append(cbInput);
}

export function prepareCol(innerCol, withPadding = true, extraClasses = '') {
    let classList = withPadding ? 'td-padding ' : '';
    if (extraClasses) classList += extraClasses;

    return $('<td/>', {class: classList}).append(innerCol);
}

export function isInputValid(input) {
    const {maxVal} = input.data() || {};
    let value = input.money().toFloat();
    let changed = false;

    if (maxVal && (value > maxVal || value < 0)) {
        changed = true;
        value = maxVal;
    }

    return {changed, value};
}

export function sumObjectsByKey(...objs) {
    return objs.reduce((a, b) => {
        for (let k in b) {
            if (b.hasOwnProperty(k))
                a[k] = (a[k] || 0) + b[k];
        }
        return a;
    }, {});
}

